import { useEffect } from 'react';
import { useLocation, useNavigate, useNavigationType } from 'react-router-dom';

export const useNavigationListener = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === 'POP') {
      // Example condition to prevent back navigation
      if (
        location.pathname.includes('duel/') &&
        !location.pathname.includes('/create-round') &&
        !location.pathname.includes('/overview')
      ) {
        // In v6, you can't directly "cancel" a navigation.
        // Instead, you can navigate the user back to where they were.
        // A positive number in navigate will go forward in history.
        navigate(1);
      }

      // Redirect away from certain pages
      if (location.pathname.includes('sign-in') || location.pathname.includes('sign-up')) {
        navigate('/home', { replace: true });
      }
    }
  }, [location, navigationType, navigate]);
};
